import Http from '../../../../network/Http'
import {NatGetTwoFactorAuthRecipients} from './NatGetTwoFactorAuthRecipients'
import {AUTHENTICATION_CODE_TYPE} from '../../../../CodeMaster'
import {ContentType} from '../../../../network/Constants'
import {NatBaseResponseInterface} from '../../common/repository/NatBaseResponseInterface'

export class NatTwoFactorAuthRepo {
    http: Http

    constructor(http: Http) {
        this.http = http
    }

    async getTwoFactorAuthRecipientsFromOwnershipTransfers(): Promise<NatGetTwoFactorAuthRecipients> {
        return await this.http.get(`/api/guest/two-factor-auth/1/recipient`)
    }

    async sendAuthCodeSmsFromOwnershipTransfers(
        authType: AUTHENTICATION_CODE_TYPE
    ): Promise<NatBaseResponseInterface> {
        return await this.http.post(
            `/api/guest/two-factor-auth/1/sms/send`,
            {
                authType: authType.value
            },
            ContentType.JSON,
        )
    }

    async sendAuthCodeEmailFromOwnershipTransfers(): Promise<NatBaseResponseInterface> {
        return await this.http.post(
            `/api/guest/two-factor-auth/1/email/send`,
            {},
            ContentType.JSON,
        )
    }

    async verifyAuthCodeSmsToOwnershipTransfers(authCode: string): Promise<NatBaseResponseInterface> {
        return await this.http.post(
            `/api/guest/two-factor-auth/1/sms/verify`,
            {
                authCode: authCode
            },
            ContentType.JSON,
        )
    }

    async verifyAuthCodeEmailToOwnershipTransfers(authCode: string): Promise<NatBaseResponseInterface> {
        return await this.http.post(
            `/api/guest/two-factor-auth/1/email/verify`,
            {
                authCode: authCode
            },
            ContentType.JSON,
        )
    }
}